export default "__VITE_ASSET__CtRnWShb__"